import { Routes } from '@angular/router';

import { TaRoutes } from '@ta/menu';

export enum EReviewsRoute {
  reviews = 'reviews',
  list = 'list',
  view = 'view',
  post = 'post',
}

TaRoutes.addRoute({
  key: EReviewsRoute.reviews,
  url: 'reviews',
  children: [
    {
      key: EReviewsRoute.list,
      url: 'list',
    },
    {
      key: EReviewsRoute.view,
      url: 'view/:type/:id',
    },
    {
      key: EReviewsRoute.post,
      url: 'review/:tenantApplicationId',
    },
  ],
});

export const reviewsRoutes: Routes = [
  {
    // Sans candidature, il n'y a rien à évaluer : on retombe sur la liste plutôt que sur un 404.
    path: 'review',
    redirectTo: 'list',
    pathMatch: 'full',
  },
  {
    path: TaRoutes.getUrl([EReviewsRoute.reviews, EReviewsRoute.list]),
    title: 'app.pages.reviews.title',
    loadComponent: () => import('./pages/reviews-list/reviews-list').then((c) => c.ReviewsListPage),
  },
  {
    path: TaRoutes.getUrl([EReviewsRoute.reviews, EReviewsRoute.view]),
    title: 'app.pages.view_review.title',
    loadComponent: () => import('./pages/reviews-view/reviews-view').then((c) => c.ReviewsViewPage),
  },
  {
    path: TaRoutes.getUrl([EReviewsRoute.reviews, EReviewsRoute.post]),
    title: 'app.pages.write_review.title',
    loadComponent: () =>
      import('./pages/create-review/create-review').then((c) => c.CreateReviewPage),
  },
];
